<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data List Part to Delivery">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="input-" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
				<app-input-textbox id="fieldset-order-qty" label-cols-lg="12" label="Order Qty" label-for="input-order-qty" size="sm" :model.sync="model.orderQty"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-delivery-qty" label-cols-lg="12" label="Delivery Qty" label-for="input-delivery-qty" size="sm" :model.sync="model.deliveryQty"  />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SuratJalanSupplyForSubcontractDetail from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractDetail';
import SuratJalanSupplyForSubcontractDetailFilter from '@/filters/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractDetailFilter';

import SuratJalanSupplyForSubcontract from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontract';
import SuratJalanSupplyForSubcontractFilter from '@/filters/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppLabel from '@/components/AppLabel';
import AppInputTextbox from '@/components/AppInputTextbox';
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import WorkOrderSupplySubContractDetailFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			parts : [],
			workOrderSupplySubContractDetails : [],
			isBusy: false,
		}
	},
	methods : {
		getSuratJalanSupplyForSubcontractDetail : async function(id) {
			this.isBusy = true;
			SuratJalanSupplyForSubcontractDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getWorkOrderSupplySubContractDetails : async function(input) {
			let filter = new WorkOrderSupplySubContractDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderSupplySubContractDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContractDetails = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getParts();
		//this.getWorkOrderSupplySubContractDetails();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getSuratJalanSupplyForSubcontractDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getParts();
				this.getWorkOrderSupplySubContractDetails();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getSuratJalanSupplyForSubcontractDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
